import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { FilterListOff } from '@mui/icons-material';
import { ActivityType, ACTIVITY_LABELS } from '../types/activity';

interface NoActivitiesMessageProps {
  selectedType: ActivityType | 'all';
  onReset: () => void;
  isOrgSpecific?: boolean;
}

export const NoActivitiesMessage: React.FC<NoActivitiesMessageProps> = ({
  selectedType,
  onReset,
  isOrgSpecific = false,
}) => {
  const getFilterLabel = () => {
    if (selectedType === 'all') {
      return '';
    }
    return ACTIVITY_LABELS[selectedType as ActivityType] || selectedType;
  };

  const getMessage = () => {
    if (selectedType === 'all') {
      return isOrgSpecific
        ? 'No activity found for this organisation.'
        : 'No activity found.';
    }

    const filterLabel = getFilterLabel().toLowerCase();
    return isOrgSpecific
      ? `No ${filterLabel} activity found for this organisation.`
      : `No ${filterLabel} activity found.`;
  };

  return (
    <Box
      sx={{
        textAlign: 'center',
        py: 4,
        px: 2,
      }}
    >
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 2 }}
      >
        {getMessage()}
      </Typography>

      {selectedType !== 'all' && (
        <Button
          variant="outlined"
          startIcon={<FilterListOff />}
          onClick={onReset}
          size="small"
        >
          Clear Filter
        </Button>
      )}
    </Box>
  );
};
